import { type ComponentProps } from 'react'
import { ChevronRight } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

interface CellChevronProps extends ComponentProps<'svg'> {}

function CellChevron({ className, ...props }: CellChevronProps) {
  return (
    <ChevronRight
      data-slot="cell-chevron"
      className={twMerge(
        'text-foreground-secondary size-4 shrink-0 transition-transform group-data-[open=true]/cell:rotate-90',
        className,
      )}
      {...props}
    />
  )
}

export { CellChevron }
